export enum CustomerType {
  DistrictMajor = 'DM',
  HouseAccount = 'HA',
  IntraCompany = 'IC',
  JobberDistributor = 'JD',
  KeyAccount = 'KY',
  Street = 'ST',
  National = 'NA',
}
